import axios from 'axios';
import Cookies from 'js-cookie';
import { v4 } from 'uuid';
import { getScreenName } from '../../../Utils/helper';
import { getApiEndpoint, getKwickpassSecretKey } from '../../../appconfig';
import { getWebUserType } from '../../../Utils/getWebUserType';
import { fireEvent } from '../../../Utils/fireEvent';
import { userDataFetcher } from '../../../datafetchers/productPage/userDataFetcher';
import { jwtDecrypt } from 'jose';

export const apiEvent = (apiName) => {
  fireEvent({
    category: 'triggered_api_call',
    base_url: apiName,
    screen_name: getScreenName(),
  });
};
export const verifyEvent = (mobileNumber) => {
  fireEvent({
    category: 'verified_contact_for_web_login',
    value: mobileNumber,
    screen_name: getScreenName(),
  });
};
export const fireLoginEvent = (category) => {
  fireEvent({
    category: category,
    screen_name: getScreenName(),
  });
};
export const fireLoginVerifyEvent = (
  category,
  autoOtp,
  otpVerificationParamsData,
) => {
  const paymentParam = {};
  if (otpVerificationParamsData) {
    paymentParam['id'] = otpVerificationParamsData.current?.id;
    paymentParam['final_price'] =
      otpVerificationParamsData.current?.final_price;
    paymentParam['conversion_params'] =
      otpVerificationParamsData.current?.conversion_param;
    paymentParam['sku_nickname'] =
      otpVerificationParamsData.current?.sku_nickname;
  }
  fireEvent({
    category: category,
    screen_name: getScreenName(),
    auto_fetched: autoOtp ? 1 : 0,
    ...paymentParam,
  });
};
export const fireClickedEvent = (cta) => {
  fireEvent({
    category: 'clicked_cta',
    parent: 'web_login',
    cta: cta,
    screen_name: getScreenName(),
  });
};
export const fireAutoOtpEvent = (category) => {
  fireEvent({
    category: category,
  });
};
export const fireAutoOtpSuccessEvent = (category, apiCallTime) => {
  let delay = (new Date() - apiCallTime.current) / 1000;
  fireEvent({
    category: category,
    delay_in_secs: delay,
  });
};
export const fireManualEnteredEvent = (category, apiCallTime) => {
  let delay = (new Date() - apiCallTime.current) / 1000;
  fireEvent({
    category: category,
    delay_in_secs: delay,
  });
};

export const loginSuccessMethod = async (token) => {
  Cookies.remove('react_user_properties');
  let userType = getWebUserType();
  const res = await userDataFetcher({ user_type: userType }, '', token);
  let user_data = JSON.stringify(res.user);
  let data = user_data ? JSON.parse(user_data) : '';
  if (user_data) {
    Cookies.set('react_user_properties', user_data, '/');

    if (data?.language) {
      Cookies.set('language', data.language == 2 ? 'hi' : 'en', '/');
    }
  } else {
    fireEvent({
      category: 'OTP_failed',
      screen_name: getScreenName(),
      support_variable: token.substring(0, 98),
      parent: data?.user_id,
    });
  }
  return res?.user;
};

export const autoFillOtp = (otpRef, verifyLogin, apiCallTime) => {
  if ('OTPCredential' in window) {
    const input = document.querySelector('input[autoComplete="one-time-code"]');
    if (!input) return;
    const ac = new AbortController();
    const form = input.closest('form');

    if (form) {
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        ac.abort();
      });
    }
    navigator.credentials
      .get({
        otp: { transport: ['sms'] },
        signal: ac.signal,
      })
      .then((otp) => {
        document.getElementById('otp').value = otp.code;
        otpRef.current = otp.code;
        fireAutoOtpSuccessEvent('otp_autoread_status', apiCallTime);
        verifyLogin(true);
      })
      .catch((err) => {
        fireEvent({
          category: 'otp_autoread_status',
          screen_name: getScreenName(),
          status: 'fail',
          delay_in_secs: (new Date() - apiCallTime.current) / 1000,
        });
        // console.log(err);
      });
  }
};

export const trueCallerHandler = (
  notFoundHandler,
  onSuccessHandler,
  loaderHandler,
) => {
  const generatedID = v4().split('-').splice(2, 5).join('-');

  window.location = `truecallersdk://truesdk/web_verify?type=btmsheet&requestNonce=${generatedID}&partnerKey=j1Hcjd95c10e6c89146b9a702cb15e3086902&partnerName=Mylo&lang=en&privacyUrl=https://mylofamily.com/privacy-policy&termsUrl=https://mylofamily.com/privacy-policy&loginPrefix=proceed&loginSuffix=verifymobile&ctaPrefix=use&ctaColor=%23ef4e5e&ctaTextColor=%23FFFFFF&btnShape=rect&skipOption=useanothernum`;

  setTimeout(() => {
    if (document.hasFocus()) {
      // console.log("Not Found - True Caller");
      notFoundHandler();
    } else {
      // console.log("Found - True Caller");
      loaderHandler(true);
      fireEvent({
        category: 'viewed_popup',
        screen_name: getScreenName(),
        parent: 'true_caller_login',
      });
      const truecallerResponsePolling = setInterval(() => {
        axios.defaults.headers.common['Authorization'] =
          process.env.NEXT_PUBLIC_ENV_LOCAL_DEFAULT_TOKEN;
        let url = `${getApiEndpoint()}api/getRequestIdUser`;
        axios
          .get(url, {
            params: {
              requestId: generatedID,
            },
          })
          .then((res) => {
            if (res?.data?.status === 200 && res?.data?.data) {
              const encryptedToken = res?.data?.data;
              Cookies.set('lu', encryptedToken, '/');
              Cookies.set('user_guid', encryptedToken, '/');
              clearInterval(truecallerResponsePolling);
              // let decryptedToken = crypto.AES.decrypt(
              //     encryptedToken,
              //     "7F6DAD1C5ABFB7498C4C736D174B2",
              // ).toString(crypto.enc.Utf8);
              Cookies.set('token', encryptedToken, {
                expires: 365,
                path: '/',
              });
              loaderHandler(false);
              fireEvent({
                category: 'OTP_verified',
                screen_name: getScreenName(),
                support_variable: 'truecaller',
                auto_fetched: 1,
              });
              onSuccessHandler();
            } else if (res?.data?.status === 400) {
              clearInterval(truecallerResponsePolling);
              fireEvent({
                category: 'clicked_cta',
                screen_name: getScreenName(),
                parent: 'true_caller_login',
                cta: 'use another number',
              });
              loaderHandler(false);
              notFoundHandler();
              // console.log(
              //     "True caller login failed",
              //     res?.data?.data?.error,
              // );
            } else if (res?.data?.status === 300) {
              // keep retrying
            } else {
              clearInterval(truecallerResponsePolling);
              loaderHandler(false);
              notFoundHandler();
            }
          })
          .catch(() => {
            clearInterval(truecallerResponsePolling);
            loaderHandler(false);
            notFoundHandler();
          });
      }, 3000);
    }
  }, 600);
};

export function disableTrueCaller() {
  return true;
}

const decodeBase64url = (str) => {
  const base64 = str.replace(/-/g, '+').replace(/_/g, '/');
  const padded = base64.padEnd(
    base64.length + ((4 - (base64.length % 4)) % 4),
    '=',
  );
  return new Uint8Array(Buffer.from(padded, 'base64'));
};

export const decodeKwickpassKpToken = async (kpToken) => {
  const secret = decodeBase64url(getKwickpassSecretKey());

  const { payload, protectedHeader } = await jwtDecrypt(kpToken, secret);

  return payload;
};
